import style from 'styled-components';

export const NoMatchPageStyleWrapper = style.div`
`;
